import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

const reimbursableFilter = ({
  expensesContext,
}: BaseFilterProps): DataTableFilter<ExpensesExpensableFilter> => {
  const options = [
    {
      label: i18n.t('expenses_v2.list.filters.reimbursable'),
      value: true,
    },
    {
      label: i18n.t('expenses_v2.list.filters.not_reimbursable'),
      value: false,
    },
  ]

  return {
    type: FilterType.Boolean,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
    ],
    onUpdateValue: () => {
      trackFilters('payment', expensesContext)
    },
    identifier: 'expensesList.reimbursableFilter',
    path: 'reimbursable',
    title: i18n.t('expenses_v2.forms.fields.payment.label'),
  }
}

export default reimbursableFilter
